import * as Comp from "../../../common/CommonComponents";
import * as common from "../../../common/common";
import http from "../../../common/http-common";
import CssClass from "../../../Styles/common.module.css";
// import ResponseTable from "../TicketResponse/ResponseTable";
import moment from "moment";
// import { marked } from "marked";
// import ReactMarkdown from 'react-markdown';
import { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { useCookies } from "react-cookie";
import { toast } from "react-toastify";
import { GetPagePermissionFn } from "../../../common/authority";
import { GetTicketButtonPermissionFn } from "../../../common/authority";
import { GetModifyPermissionFn } from "../../../common/authority";
import TicketAttachmentModal from "./TicketAttachmentModal";
// import PostResponse from "../TicketResponse/PostResponse";
import AckTicket from "./AckTicket";
import CloseTicket from "./CloseTicket";
import CancelTicket from "./CancelTicket";
import ResolveTicket from "./ResolveTicket";
import VerifyTicket from "./VerifyTicket";
import PostReply from "../TicketResponse/PostReply";
import ReverseTicketStatus from "./ReverseTicketStatus";
// import ResponseChat from "../TicketResponse/ResponseChat";
import NewResponseChat from "../TicketResponse/NewResponseChat";


const PAGE_NAME = "ViewTicket.js_";
const MODULE_ID = "WEB_TKT_002";

const ViewTicket = (props) => {
  document.title =  common.c_TITLE + " - View Ticket" ;
  const [cookies] = useCookies([]);
  const [userId] = useState(cookies.USER_ID);
  const navigate = useNavigate();

  // const location = useLocation();
  // const ticketNo = location.state?.ticketNo;

  // const location = useLocation();
  // const queryParams = new URLSearchParams(location.search);
  const queryParams = new URLSearchParams(window.location.search);
  const ticketNo = queryParams.get('_ticketNo');
  const ticketMstId = queryParams.get('_id');
  // const ticketMstId = window["TICKET_MST_ID"]

  const [viewData, setViewData] = useState([]);
  const [responseData, setResponseData] = useState([]);
  const [verifiedData, setVerifiedData] = useState([]);
  const [resolvedData, setResolvedData] = useState([]);
  const [closedData, setClosedData] = useState([]);
  const [editData, setEditData] = useState([]);
  const [ticketAttachment, setTicketAttachment] = useState([]);
  const [dataToBeSelect, setDataToBeSelect] = useState({
    TicketStatus: [],
    Organization: [],
    System: [],
    Category: [],
    Priority: [],
    EMAIL_TO: [],
  });
  const [inputError, setInputError] = useState({
    TICKET_NUM_FORMAT: "",
  });

  const [originalAgent, setOriginalAgent] = useState([]);
  const [originalAgentName, setOriginalAgentName] = useState([]);
  const [originalCompany, setOriginalCompany] = useState([]);
  const [originalSystem, setOriginalSystem] = useState([]);
  const [originalOwner, setOriginalOwner] = useState([]);
  
  //Get selection agent, company, system & ticket owner
  const [agentDetailList, setAgentDetailList] = useState([]);
  const [selectedAgentDetail, setSelectedAgentDetail] = useState([]);
  const [companyDetailList, setCompanyDetailList] = useState([]);
  const [selectedCompanyDetail, setSelectedCompanyDetail] = useState([]);
  const [systemDetailList, setSystemDetailList] = useState([]);
  const [selectedSystemDetail, setSelectedSystemDetail] = useState([]);
  const [ticketOwnerDetailList, setTicketOwnerDetailList] = useState([]);
  const [selectedTicketOwnerDetail, setSelectedTicketOwnerDetail] = useState([]);

  const [showAttachment, setShowAttachment] = useState(false);
  const [showReply, setShowReply] = useState(false);
  const [showAck, setShowAck] = useState(false);
  const [showClose, setShowClose] = useState(false);
  const [showCancel, setShowCancel] = useState(false);
  const [showReverse, setShowReverse] = useState(false);
  const [showResolve, setShowResolve] = useState(false);
  const [showVerify, setShowVerify] = useState(false);

  const [reload, setReload] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingText, setLoadingText] = useState("Loading...");

  const [actionAuthority, setActionAuthority] = useState({
    READ: "N",
    WRITE: "N",
  });

  const [buttonAuthority, setButtonAuthority] = useState({
    UPDATE: "N",
    ACKNOWLEDGE: "N",
    CLOSE: "N",
    CANCEL: "N",
    POST_REPLY: "N",
    REVERSE_STATUS: "N",
    RESOLVE: "N",
    VERIFY: "N",
    REJECT: "N",
    UPDATE_VERIFY_DETAIL: "N",
    EDIT_REPLY: "N",
    DELETE_REPLY: "N",
  });

  const [modifyAuthority, setModifyAuthority] = useState({
    MODIFY_AGENT: "N",
    MODIFY_COMPANY:"N",
    MODIFY_SYSTEM:"N",
    MODIFY_TICKET_OWNER: "N",
  });

  //SystemAttachment
  const [systemAttachment, setSystemAttachment] = useState([]);

  useEffect(() => {
    let promise = GetPagePermissionFn(userId, MODULE_ID);
    promise.then(
      (result) => {
        setActionAuthority(result);
        if (result.READ === "N") {
          navigate("/Home");
        }
      },
      (error) => {
        setActionAuthority({
          READ: "N",
          WRITE: "N",
        });
        common.c_LogWebError(PAGE_NAME, "GetPagePermissionFn", error);
        toast.error(error);
        navigate("/Home");
      }
    );
  }, [userId, navigate]);

  useEffect(() => {
    let promise = GetTicketButtonPermissionFn(userId, MODULE_ID);
    promise.then(
      (result) => {
        setButtonAuthority(result);
      },
      (error) => {
        setButtonAuthority({
          UPDATE: "N",
          ACKNOWLEDGE: "N",
          CLOSE: "N",
          CANCEL: "N",
          POST_REPLY: "N",
          REVERSE_STATUS: "N",
          RESOLVE: "N",
          VERIFY: "N",
          REJECT: "N",
          UPDATE_VERIFY_DETAIL: "N",
          EDIT_REPLY: "N",
          DELETE_REPLY: "N",
        });
        common.c_LogWebError(PAGE_NAME, "GetPagePermissionFn", error);
        toast.error(error);
      }
    );
  }, [actionAuthority, userId])

  useEffect(() => {
    let promise = GetModifyPermissionFn(userId, MODULE_ID);
    promise.then(
      (result) => {
        //console.log("Modify Authority", result);
        setModifyAuthority(result);
      },
      (error) => {
        setModifyAuthority({
          MODIFY_AGENT: "N",
          MODIFY_TICKET_OWNER: "N",
          MODIFY_COMPANY: "N",
          MODIFY_SYSTEM: "N",
        });
        common.c_LogWebError(PAGE_NAME, "GetPagePermissionFn", error);
        toast.error(error);
      }
    );
  }, [actionAuthority, userId])

  useEffect(() => {
    if (actionAuthority.READ === "Y") {
      let functionName = "";

      try {
        functionName = "Update Ticket Read Flag";
        onLoadingHandler(true, "Updating ticket read flag, please wait...");

        http
          .put(
            `api/ticket/UpdateTicketReadFlag?_ticketNo=${ticketNo}&_ticketId=${ticketMstId}&_user=${userId}`,
            { timeout: 100000 }
          )
          .then((response) => {
            // toast.success("Ticket Read Flag Updated.");
          })
          .catch((err) => {
            toast.error("Error on update ticket read flag. Please try again.");
            common.c_LogWebError(PAGE_NAME, functionName, err);
          })
          .finally(() => {
            onLoadingHandler(false, "Loading...");
          });
      } catch (err) {
        toast.error("Error on update ticket read flag. Please try again.");
        common.c_LogWebError(PAGE_NAME, functionName, err);
      }
    }
  }, [reload, ticketNo, actionAuthority, userId]);

  //SystemAttachment
  useEffect(() => {
    if (actionAuthority.READ === "Y" && editData.SYSTEM_MST_ID) {

      http.get(
        `api/SystemSetup/GetSystemAttachment?_systemId=${editData.SYSTEM_MST_ID}`
      )
      .then((res) => {
        setSystemAttachment(res.data || []);
      })
      .catch(() => {
        setSystemAttachment([]);
      });
    }
  }, [editData.SYSTEM_MST_ID, actionAuthority]);
  
  // <!--------------- for  ------------------------->
  //#region UseEffect
  // useEffect(() => {
  //   if (actionAuthority.READ === "Y") {
  //     let functionName = "";
  
  //     try {
  //       functionName = "Get Ticket Information for agent & ticket owner";
  
  //       onLoadingHandler(true, "Getting agent & ticket owner information, please wait...");
  
  //       const listItems = [];
  
  //       http
  //         .get(
  //           `api/ticket/ViewTicketDetails?_ticketNo=${ticketNo}&_ticketId=${ticketMstId}&_user=${userId}`,
  //           { timeout: 100000 }
  //         )
  //         .then((response) => {
  //           if (response.data.length > 0) {
  //             response.data.forEach((data) => {
  //               listItems.push({
  //                 TICKET_MST_ID: data.TICKET_MST_ID,
  //                 TICKET_NUM: data.TICKET_NUM,
  //                 ACKNOWLEDGED_BY: data.ACKNOWLEDGED_BY,
  //                 ACKNOWLEDGED_NAME: data.ACKNOWLEDGED_NAME,
  //                 CREATE_BY: data.CREATE_BY,
  //                 CREATE_NAME: data.CREATE_NAME,
  //               });
  //             });
  
  //             setViewData(listItems[0]);
  
  //             // Store original agent and ticket owner
  //             setOriginalAgent(listItems[0].ACKNOWLEDGED_BY);
  //             setOriginalOwner(listItems[0].CREATE_NAME);
  //           }
  //         })
  //         .catch((err) => {
  //           toast.error("Error on getting agent & ticket owner information. Please try again.");
  //           common.c_LogWebError(PAGE_NAME, functionName, err);
  //         })
  //         .finally(() => {
  //           setLoading(false);
  //           setLoadingText("Loading...");
  //         });
  //     } catch (err) {
  //       toast.error("Error on getting agent & ticket owner information. Please try again.");
  //       common.c_LogWebError(PAGE_NAME, functionName, err);
  //     }
  //   }
  // }, [reload, ticketNo, actionAuthority, userId]);

  useEffect(() => {

  if (actionAuthority.READ === "Y") {
      // setAgentFieldDisabled(false);
      setAgentDetailList([]);
      // setSystemDetailList([]);
      const listItems = [];

      try {
        http
        .get("api/ticket/GetAllExistAgent?_userId=" + userId, { timeout: 10000000 })
        .then((response) => {
            if (response.data.length > 0) {
              response.data.forEach((data, counter) => {
                  listItems.push({
                      key: data.USER_ID,
                      value: data.USER_ID,
                      label: data.USER_SHORT_NAME,
                      isActive: data.ACTIVE_FLAG === "Y",
                  });
              });
              setAgentDetailList(listItems);
            }
            if (response.data[0].ORG_CATEGORY_NAME === "CUSTOMER") {
              // setAgentFieldDisabled(true);
              setSelectedAgentDetail({
                key: response.data[0].USER_ID,
                value: response.data[0].USER_ID,
                label: response.data[0].USER_SHORT_NAME
              });
            }
          })
          .catch((err) => {
            toast.error("Error on getting all agent list. Please try again.1");
            common.c_LogWebError(PAGE_NAME, err.stack);
          })
          // .finally(()=>{

          // })
      } catch (err) {
          toast.error("Error on getting all agent list. Please try again.");
          common.c_LogWebError(PAGE_NAME, err.stack);
      }
    }
  }, [actionAuthority, userId]);

  useEffect(() => {

  if (actionAuthority.READ === "Y") {
      // setCompanyFieldDisabled(false);
      setCompanyDetailList([]);
      // setSystemDetailList([]);
      const listItems = [];

      try {
        http
        .get("api/ticket/GetOrgList?_user=" + userId, { timeout: 10000000 })
        .then((response) => {
            if (response.data.length > 0) {
              response.data.forEach((data, counter) => {
                  listItems.push({
                      key: data.ORG_ID,
                      value: data.ORG_ID,
                      label: data.ORG_NAME,
                  });
              });
              setCompanyDetailList(listItems);
            }
            if (response.data[0].ORG_CATEGORY_NAME === "CUSTOMER") {
              // setCompanyFieldDisabled(true);
              setSelectedCompanyDetail({
                key: response.data[0].ORG_ID,
                value: response.data[0].ORG_ID,
                label: response.data[0].ORG_NAME
              });
            }
          })
          .catch((err) => {
            toast.error("Error on getting all company list. Please try again.1");
            common.c_LogWebError(PAGE_NAME, err.stack);
          })
          // .finally(()=>{

          // })
      } catch (err) {
          toast.error("Error on getting all company list. Please try again.");
          common.c_LogWebError(PAGE_NAME, err.stack);
      }
    }
  }, [actionAuthority, userId]);

  useEffect(() => {
  if (actionAuthority.READ !== "Y") return;

  setSystemDetailList([]);
  const listItems = [];

  const orgId = selectedCompanyDetail?.value || editData?.ORG_ID;
  if (!orgId) {
    //console.warn("ORG_ID not available. Skipping system fetch.");
    return;
  }
  //console.log("Fetching systems with orgId:", orgId);

  http.get(`api/ticket/GetSystemList?_user=${userId}&_org=${orgId}`, { timeout: 10000000 })
    .then((response) => {
      if (response.data.length > 0) {
        response.data.forEach((data) => {
          listItems.push({
            key: data.SYSTEM_MST_ID,
            value: data.SYSTEM_MST_ID,
            label: data.SYSTEM_MST_NAME,
          });
        });
        setSystemDetailList(listItems);

        if (response.data[0].ORG_CATEGORY_NAME === "CUSTOMER") {
          setSelectedSystemDetail({
            key: response.data[0].SYSTEM_MST_ID,
            value: response.data[0].SYSTEM_MST_ID,
            label: response.data[0].SYSTEM_MST_NAME,
          });
        }
      }
    })
    .catch((err) => {
      toast.error("Error on getting all system list. Please try again.");
      common.c_LogWebError(PAGE_NAME, err.stack);
    });
}, [actionAuthority, userId, selectedCompanyDetail, editData]);


  useEffect(() => {

    if (actionAuthority.READ === "Y") {
        // setTicketOwnerFieldDisabled(false);
        setTicketOwnerDetailList([]);
        // setSystemDetailList([]);
        const listItems = [];

        try {
            http
            .get("api/ticket/GetExistTicketOwnerDetail?_userId=" + userId, { timeout: 10000000 })
            .then((response) => {
                if (response.data.length > 0) {
                    response.data.forEach((data, counter) => {
                        listItems.push({
                            key: data.USER_ID,
                            value: data.USER_ID,
                            label: data.USER_SHORT_NAME,
                            isActive: data.ACTIVE_FLAG === "Y",
                        });
                    });
                    setTicketOwnerDetailList(listItems);
                }
                if (response.data[0].ORG_CATEGORY_NAME === "CUSTOMER") {
                    // setTicketOwnerFieldDisabled(true);
                    setSelectedTicketOwnerDetail({
                        key: response.data[0].USER_ID,
                        value: response.data[0].USER_ID,
                        label: response.data[0].USER_SHORT_NAME,
                    });
                }
            })
            .catch((err) => {
                toast.error("Error on getting all user list. Please try again.1");
                common.c_LogWebError(PAGE_NAME, err.stack);
            })
            // .finally(()=>{

            // })
        } catch (err) {
            toast.error("Error on getting all user list. Please try again.");
            common.c_LogWebError(PAGE_NAME, err.stack);
        }
    }
}, [actionAuthority, userId]);
  //#endregion



  // const ticketNoInputRef = useRef();
  const agentInputRef = useRef();
  const companyInputRef = useRef();
  const systemInputRef = useRef();
  // const ackDatetimeInputRef = useRef();
  const serviceTimeInputRef = useRef();
  const ticketOwnerInputRef = useRef();
  const subjectInputRef = useRef();
  const remarkInputRef = useRef();
  const detailsInputRef = useRef();
  const standbyTargetMandaysRef = useRef();

  const showAttachmentModal = () => {
    setShowAttachment(!showAttachment);
  };

  const hideAttachmentModal = () => {
    setShowAttachment(!showAttachment);
  };

  const showReplyModal = () => {
    setShowReply(!showReply);
  };

  const hideReplyModal = () => {
    setShowReply(!showReply);
  };

  const showAckModal = () => {
    setShowAck(!showAck);
  }

  const hideAckModal = () => {
    setShowAck(!showAck);
  }

  const showCloseModal = () => {
    setShowClose(!showClose);
  }

  const hideCloseModal = () => {
    setShowClose(!showClose);
  }

  const showCancelModal = () => {
    setShowCancel(!showCancel);
  }

  const hideCancelModal = () => {
    setShowCancel(!showCancel);
  }

  const showReverseModal = () => {
    setShowReverse(!showReverse);
    
  }

  const hideReverseModal = () => {
    setShowReverse(!showReverse);
  }

  const showResolveModal = () => {
    setShowResolve(!showResolve);
    
  }

  const hideResolveModal = () => {
    setShowResolve(!showResolve);
  }
  
  const showVerifyModal = () => {
    setShowVerify(!showVerify);
    
  }

  const hideVerifyModal = () => {
    setShowVerify(false);
  }
  useEffect(() => {
    if (actionAuthority.READ === "Y") {
      let functionName = "";

      try {
        
        functionName = "Get Ticket Information";

        onLoadingHandler(true, "Getting ticket information, please wait...");

        setViewData([]);

        const listItems = [];

        http
          .get(
            `api/ticket/ViewTicketDetails?_ticketNo=${ticketNo}&_ticketId=${ticketMstId}&_user=${userId}`,
            { timeout: 100000 }
          )
          .then((response) => {
            if (response.data.length > 0) {
              response.data.forEach((data) => {
                listItems.push({
                  TICKET_MST_ID: data.TICKET_MST_ID,
                  TICKET_NUM: data.TICKET_NUM,
                  ORG_ID: data.ORG_ID,
                  ORG_NAME: data.ORG_NAME,
                  SYSTEM_MST_ID: data.SYSTEM_MST_ID,
                  SYSTEM_MST_NAME: data.SYSTEM_MST_NAME,
                  SUBJECT: data.SUBJECT,
                  INTERNAL_NOTE: data.INTERNAL_NOTE,
                  TICKET_DETAILS: data.TICKET_DETAILS,
                  CREATE_BY: data.CREATE_BY,
                  CREATE_NAME: data.CREATE_NAME,
                  CREATE_DATETIME: data.CREATE_DATETIME,
                  TICKET_CATEGORY_ID: data.TICKET_CATEGORY_ID,
                  TICKET_CATEGORY_NAME: data.TICKET_CATEGORY_NAME,
                  TICKET_PRIORITY_TYPE_ID: data.TICKET_PRIORITY_TYPE_ID,
                  TICKET_PRIORITY_TYPE_NAME: data.TICKET_PRIORITY_TYPE_NAME,
                  TICKET_STATUS_TYPE_ID: data.TICKET_STATUS_TYPE_ID,
                  TICKET_STATUS_TYPE_NAME: data.TICKET_STATUS_TYPE_NAME,
                  ACKNOWLEDGED_BY: data.ACKNOWLEDGED_BY,
                  ACKNOWLEDGED_NAME: data.ACKNOWLEDGED_NAME,
                  ACKNOWLEDGED_DATETIME: data.ACKNOWLEDGED_DATETIME,
                  CANCELLED_BY: data.CANCELLED_BY,
                  CANCELLED_NAME: data.CANCELLED_NAME,
                  CANCELLED_DATETIME: data.CANCELLED_DATETIME,
                  RESPONSE_DETAILS: data.RESPONSE_DETAILS,
                  TARGET_MANDAYS: data.TARGET_MANDAYS,
                  TOTAL_COMPLETE_TIME: data.TOTAL_COMPLETE_TIME,
                  ATTACHMENT_ID: data.ATTACHMENT_ID,
                  STANDBY_FLAG: data.STANDBY_FLAG,
                  FROM_DATETIME: data.FROM_DATETIME,
                  TO_DATETIME: data.TO_DATETIME,
                  TICKET_STANDBY_ID: data.TICKET_STANDBY_ID,
                  STANDBY_TARGET_MANDAYS: data.STANDBY_TARGET_MANDAYS,
                  UPDATE_ID: data.UPDATE_ID,
                  UPDATE_DATETIME: data.UPDATE_DATETIME,
                  READ_FLAG: data.READ_FLAG,
                  READ_BY: data.READ_BY,
                  VERIFY_DETAIL: data.VERIFY_DETAIL, 
                });
              });
              setViewData(listItems[0]);
              //console.log(listItems);
              // Store original agent and ticket owner
              setOriginalAgent(listItems[0].ACKNOWLEDGED_BY);
              setOriginalAgentName(listItems[0].ACKNOWLEDGED_NAME);
              setOriginalCompany(listItems[0].ORG_NAME);
              setOriginalSystem(listItems[0].SYSTEM_MST_NAME);
              setOriginalOwner(listItems[0].CREATE_NAME);
            }
          })
          .catch((err) => {
            toast.error("Error on getting ticket information. Please try again.");
            common.c_LogWebError(PAGE_NAME, functionName, err);
          })
          .finally(() => {
            setLoading(false);
            setLoadingText("Loading...");
          });
      } catch (err) {
        toast.error("Error on getting ticket information. Please try again.");
        common.c_LogWebError(PAGE_NAME, functionName, err);
      }
    }   
  }, [reload, ticketNo, actionAuthority, userId]);

  const attachmentId = editData.ATTACHMENT_ID;

  useEffect(() => {
    if (actionAuthority.READ === "Y") {
      let functionName = "";

      try {
        functionName = "Get Ticket Attachment";

        onLoadingHandler(true, "Getting ticket attachment, please wait...");

        setTicketAttachment([]);

        const listItems = [];

        http
          .get(
            `api/ticket/GetAttachment?_attachmentId=${attachmentId}&_user=${userId}`,
            { timeout: 100000 }
          )
          .then((response) => {
            if (response.data.length > 0) {
              response.data.forEach((data, counter) => {
                listItems.push({
                  key: counter,
                  ATTACHMENT_ID: data.ATTACHMENT_ID,
                  ATTACHMENT_NAME: data.ATTACHMENT_NAME,
                  ATTACHMENT_PATH: data.ATTACHMENT_PATH,
                });
              });
            }
            setTicketAttachment(listItems);
          })
          .catch((err) => {
            toast.error("Error on getting attachment. Please try again.");
            common.c_LogWebError(PAGE_NAME, functionName, err);
          })
          .finally(() => {
            onLoadingHandler(false, "Loading...");
          });
      } catch (err) {
        toast.error("Error on getting attachment. Please try again.");
        common.c_LogWebError(PAGE_NAME, functionName, err);
      }
    }
  }, [reload, actionAuthority, userId, attachmentId]);

  const ticketId = viewData.TICKET_MST_ID;

  useEffect(() => {
    if (actionAuthority.READ === "Y") {
      let functionName = "";

      try {
        functionName = "Get Ticket Response";

        onLoadingHandler(true, "Getting response, please wait...");

        setResponseData([]);

        const listItems = [];

        http
          .get(
            `api/response/GetAllTicketResponse?_ticketId=${ticketId}&_user=${userId}`,
            { timeout: 100000 }
          )
          .then((response) => {
            if (response.data.length > 0) {
              response.data.forEach((data) => {
                listItems.push({
                  TICKET_MST_ID: data.TICKET_MST_ID,
                  RESPONSE_DETAILS: data.RESPONSE_DETAILS,
                  TICKET_RESPONSE_ID: data.TICKET_RESPONSE_ID,
                  ATTACHMENT_ID: data.ATTACHMENT_ID,
                  DEPLOYMENT_ATTACHMENT_ID: data.DEPLOYMENT_ATTACHMENT_ID,
                  UPDATE_ID: data.UPDATE_ID,
                  UPDATE_NAME: data.UPDATE_NAME,
                  UPDATE_DATETIME: data.UPDATE_DATETIME,
                  STATUS: data.STATUS,
                });
              });
              setResponseData(listItems);
                    //console.log (listItems) ;
            }
          })
          .catch((err) => {
            toast.error("Error on getting ticket response. Please try again.");
            common.c_LogWebError(PAGE_NAME, functionName, err);
          })
          .finally(() => {
            onLoadingHandler(false, "Loading...");
          });
      } catch (err) {
        toast.error("Error on getting ticket response. Please try again.");
        common.c_LogWebError(PAGE_NAME, functionName, err);
      }
    }
  }, [reload, actionAuthority, userId, ticketId]);

  useEffect(() => {
    if (actionAuthority.READ === "Y") {
      let functionName = "";

      try {
        functionName = "Get Ticket Verified Response";

        onLoadingHandler(true, "Getting response, please wait...");

        setVerifiedData([]);

        const listItems = [];
        http
          .get(
            `api/response/GetVerifiedTickets?_ticketId=${ticketId}&_user=${userId}`,
            { timeout: 100000 }
          )
          .then((response) => {
            if (response.data.length > 0) {
              response.data.forEach((data) => {
                listItems.push({
                  TICKET_MST_ID: data.TICKET_MST_ID,
                  UPDATE_ID: data.UPDATE_ID,
                  UPDATE_NAME: data.UPDATE_NAME,
                  UPDATE_DATETIME: data.VERIFIED_DATETIME,
                  RESPONSE_DETAILS: "Ticket verified",
                });
              });
              setVerifiedData(listItems);
            }
          })
          .catch((err) => {
            toast.error("Error on getting ticket verified response. Please try again.");
            common.c_LogWebError(PAGE_NAME, functionName, err);
          })
          .finally(() => {
            onLoadingHandler(false, "Loading...");
          });
      } catch (err) {
        toast.error("Error on getting ticket verified response. Please try again.");
        common.c_LogWebError(PAGE_NAME, functionName, err);
      }
    }
  }, [reload, actionAuthority, userId, ticketId]);

  useEffect(() => {
    if (actionAuthority.READ === "Y") {
      let functionName = "";

      try {
        functionName = "Get Ticket Resolved Response";

        onLoadingHandler(true, "Getting response, please wait...");

        setResolvedData([]);

        const listItems = [];
        http
          .get(
            `api/response/GetResolvedTickets?_ticketId=${ticketId}&_user=${userId}`,
            { timeout: 100000 }
          )
          .then((response) => {
            if (response.data.length > 0) {
              response.data.forEach((data) => {
                listItems.push({
                  TICKET_MST_ID: data.TICKET_MST_ID,
                  UPDATE_ID: data.UPDATE_ID,
                  UPDATE_NAME: data.UPDATE_NAME,
                  UPDATE_DATETIME: data.RESOLVED_DATETIME,
                  RESPONSE_DETAILS: "Ticket resolved",
                });
              });
              setResolvedData(listItems);
            }
          })
          .catch((err) => {
            toast.error("Error on getting ticket resolved response. Please try again.");
            common.c_LogWebError(PAGE_NAME, functionName, err);
          })
          .finally(() => {
            onLoadingHandler(false, "Loading...");
          });
      } catch (err) {
        toast.error("Error on getting ticket resolved response. Please try again.");
        common.c_LogWebError(PAGE_NAME, functionName, err);
      }
    }
  }, [reload, actionAuthority, userId, ticketId]);

  useEffect(() => {
    if (actionAuthority.READ === "Y") {
      let functionName = "";

      try {
        functionName = "Get Ticket Closed Response";

        onLoadingHandler(true, "Getting response, please wait...");

        setVerifiedData([]);

        const listItems = [];
        http
          .get(
            `api/response/GetClosedTickets?_ticketId=${ticketId}&_user=${userId}`,
            { timeout: 100000 }
          )
          .then((response) => {
            if (response.data.length > 0) {
              response.data.forEach((data) => {
                listItems.push({
                  TICKET_MST_ID: data.TICKET_MST_ID,
                  UPDATE_ID: data.UPDATE_ID,
                  UPDATE_NAME: data.UPDATE_NAME,
                  UPDATE_DATETIME: data.CLOSED_DATETIME,
                  RESPONSE_DETAILS: "Ticket closed",
                });
              });
              setClosedData(listItems);
            }
          })
          .catch((err) => {
            toast.error("Error on getting ticket closed response. Please try again.");
            common.c_LogWebError(PAGE_NAME, functionName, err);
          })
          .finally(() => {
            onLoadingHandler(false, "Loading...");
          });
      } catch (err) {
        toast.error("Error on getting ticket closed response. Please try again.");
        common.c_LogWebError(PAGE_NAME, functionName, err);
      }
    }
  }, [reload, actionAuthority, userId, ticketId]);

  useEffect(() => {
    let functionName = "";

    try {
      functionName = "useEffect Get User List";
      onLoadingHandler(true, "Getting User List, please wait...");
      setDataToBeSelect({EMAIL_TO: []})
      http
        .get(`api/response/GetEmailToList?_ticketNo=${ticketNo}&_user=${userId}`,
        { timeout: 10000000 })
        .then((response) => {
          const listItems = [];
          for (var i = 0; i < response.data.length; i++) {
            listItems.push({
              key: response.data[i].EMAIL,
              value: response.data[i].EMAIL,
              label: response.data[i].USER_SHORT_NAME,
            });
          }
          // setCategoryData(listItems);
          setDataToBeSelect((prevState) => ({
            ...prevState,
            EMAIL_TO: [...listItems],
          }));
        })
        .catch((err) => {
          toast.error("Error on getting user List. Please try again.");
          common.c_LogWebError(props.page, functionName, err);
        })
        .finally(() => {
          onLoadingHandler(false, "Loading...");
        });
    } catch (err) {
      toast.error("Error on getting user List. Please try again.");
      common.c_LogWebError(props.page, functionName, err);
    }
}, [reload, ticketNo, /*ticketId,*/ userId]);

  // useEffect(() => {
  //   let functionName = "";

  //   try {
  //     functionName = "useEffect Get All Ticket Status Type";
  //     setLoading(true);
  //     setLoadingText("Getting Ticket Status Type List, please wait...");
  //     http
  //       .get("api/ticket/GetTicketStatus?_user=" + userId)
  //       .then((response) => {
  //         const listItems = [];
  //         for (var i = 0; i < response.data.length; i++) {
  //           listItems.push({
  //             key: response.data[i].TICKET_STATUS_TYPE_ID,
  //             value: response.data[i].TICKET_STATUS_TYPE_ID,
  //             label: response.data[i].TICKET_STATUS_TYPE_NAME,
  //           });
  //         }
  //         // setTicketStatus(listItems);
  //         setDataToBeSelect((prevState) => ({
  //           ...prevState,
  //           TicketStatus: [...listItems],
  //         }));
  //       })
  //       .catch((err) => {
  //         toast.error("Error on getting ticket status. Please try again.");
  //         common.c_LogWebError(props.page, functionName, err);
  //       });
  //   } catch (err) {
  //     toast.error("Error on getting ticket status. Please try again.");
  //     common.c_LogWebError(props.page, functionName, err);
  //   }
  // }, [reload, /*actionAuthority,*/ userId]);

  // useEffect(() => {
  //   if (actionAuthority.READ === "Y") {
  //     let functionName = "";

  //     try {
  //       functionName = "useEffect Get All Category";
  //       setLoading(true);
  //       setLoadingText("Getting Category List, please wait...");
  //       http
  //         .get("api/ticket/GetCategoryList?_user=" + userId)
  //         .then((response) => {
  //           const listItems = [];
  //           for (var i = 0; i < response.data.length; i++) {
  //             listItems.push({
  //               key: response.data[i].TICKET_CATEGORY_ID,
  //               value: response.data[i].TICKET_CATEGORY_ID,
  //               label: response.data[i].TICKET_CATEGORY_NAME,
  //             });
  //           }
  //           // setCategoryData(listItems);
  //           setDataToBeSelect((prevState) => ({
  //             ...prevState,
  //             Category: [...listItems],
  //           }));
  //         })
  //         .catch((err) => {
  //           toast.error("Error on getting category. Please try again.");
  //           common.c_LogWebError(props.page, functionName, err);
  //         });
  //     } catch (err) {
  //       toast.error("Error on getting category. Please try again.");
  //       common.c_LogWebError(props.page, functionName, err);
  //     }
  //   }  
  // }, [reload, actionAuthority, userId]);

  // useEffect(() => {
  //   if (actionAuthority.READ === "Y") {
  //     let functionName = "";

  //     try {
  //       functionName = "useEffect Get All Priority Type";
  //       setLoading(true);
  //       setLoadingText("Getting Priority Type List, please wait...");
  //       http
  //         .get("api/ticket/GetPriorityList?_user=" + userId)
  //         .then((response) => {
  //           const listItems = [];
  //           for (var i = 0; i < response.data.length; i++) {
  //             listItems.push({
  //               key: response.data[i].TICKET_PRIORITY_TYPE_ID,
  //               value: response.data[i].TICKET_PRIORITY_TYPE_ID,
  //               label: response.data[i].TICKET_PRIORITY_TYPE_NAME,
  //             });
  //           }
  //           // setPriorityData(listItems);
  //           setDataToBeSelect((prevState) => ({
  //             ...prevState,
  //             Priority: [...listItems],
  //           }));
  //         })
  //         .catch((err) => {
  //           toast.error("Error on getting priority type. Please try again.");
  //           common.c_LogWebError(props.page, functionName, err);
  //         });
  //     } catch (err) {
  //       toast.error("Error on getting priority type. Please try again.");
  //       common.c_LogWebError(props.page, functionName, err);
  //     }
  //   }  
  // }, [reload, actionAuthority, userId]);

  useEffect(() => {
      if (viewData != null) {
        setEditData({
          TICKET_MST_ID:
            viewData.TICKET_MST_ID === null ? "" : viewData.TICKET_MST_ID,
          TICKET_NUM: viewData.TICKET_NUM === null ? "" : viewData.TICKET_NUM,
          ORG_ID: viewData.ORG_ID === null ? "" : viewData.ORG_ID,
          ORG_NAME: viewData.ORG_NAME === null ? "" : viewData.ORG_NAME,
          SYSTEM_MST_ID:
            viewData.SYSTEM_MST_ID === null ? "" : viewData.SYSTEM_MST_ID,
          SYSTEM_MST_NAME:
            viewData.SYSTEM_MST_NAME === null ? "" : viewData.SYSTEM_MST_NAME,
          SUBJECT: viewData.SUBJECT === null ? "" : viewData.SUBJECT,
          TICKET_DETAILS:
              viewData.TICKET_DETAILS === null ? "" : viewData.TICKET_DETAILS,
          TICKET_STATUS_TYPE_ID:
            viewData.TICKET_STATUS_TYPE_ID === null
              ? ""
              : viewData.TICKET_STATUS_TYPE_ID,
          TICKET_STATUS_TYPE_NAME:
            viewData.TICKET_STATUS_TYPE_NAME === null
              ? ""
              : viewData.TICKET_STATUS_TYPE_NAME,

          CREATE_DATETIME:
            viewData.CREATE_DATETIME === null ? "" : viewData.CREATE_DATETIME,
          CREATE_BY: viewData.CREATE_BY === null ? "" : viewData.CREATE_BY,
          CREATE_NAME:
            viewData.CREATE_NAME === null ? "" : viewData.CREATE_NAME,
          ACKNOWLEDGED_DATETIME:
            viewData.ACKNOWLEDGED_DATETIME === null
              ? ""
              : viewData.ACKNOWLEDGED_DATETIME,
          ACKNOWLEDGED_BY:
            viewData.ACKNOWLEDGED_BY === null ? "" : viewData.ACKNOWLEDGED_BY,
          ACKNOWLEDGED_NAME:
            viewData.ACKNOWLEDGED_NAME === null
              ? ""
              : viewData.ACKNOWLEDGED_NAME,
          CANCELLED_DATETIME:
            viewData.CANCELLED_DATETIME === null ? "" : viewData.CANCELLED_DATETIME,
          CANCELLED_BY:
            viewData.CANCELLED_BY === null ? "" : viewData.CANCELLED_BY,
          CANCELLED_NAME:
            viewData.CANCELLED_NAME === null ? "" : viewData.CANCELLED_NAME,
          RESPONSE_DETAILS:
            viewData.RESPONSE_DETAILS === null ? "" : viewData.RESPONSE_DETAILS,
          TARGET_MANDAYS:
            viewData.TARGET_MANDAYS === null
              ? ""
              : viewData.TARGET_MANDAYS,    
          TOTAL_COMPLETE_TIME:
            viewData.TOTAL_COMPLETE_TIME === null
              ? ""
              : viewData.TOTAL_COMPLETE_TIME,
          INTERNAL_NOTE: viewData.INTERNAL_NOTE === null ? "" : viewData.INTERNAL_NOTE,
          ATTACHMENT_ID:
            viewData.ATTACHMENT_ID === null ? "" : viewData.ATTACHMENT_ID,
          TICKET_STANDBY_ID: viewData.TICKET_STANDBY_ID === null ? "" : viewData.TICKET_STANDBY_ID,
          FROM_DATETIME: viewData.FROM_DATETIME === null ? "" : viewData.FROM_DATETIME,
          TO_DATETIME: viewData.TO_DATETIME === null ? "" : viewData.TO_DATETIME,
          STANDBY_TARGET_MANDAYS: viewData.STANDBY_TARGET_MANDAYS === null ? "" : viewData.STANDBY_TARGET_MANDAYS,
          UPDATE_DATETIME:
            viewData.UPDATE_DATETIME === null ? "" : viewData.UPDATE_DATETIME,
          READ_FLAG: viewData.READ_FLAG === null ? "" : viewData.READ_FLAG,
          READ_BY: viewData.READ_BY === null ? "" : viewData.READ_BY,
          VERIFY_DETAIL: viewData.VERIFY_DETAIL,
        });
      }
    }, [reload, viewData] /*[editData]*/);

  // useEffect(() => {
  //   if (dataToBeSelect !== undefined && dataToBeSelect !== null) {
  //     setDataToBeSelect({
  //       TicketStatus:
  //         dataToBeSelect.TicketStatus === null
  //           ? []
  //           : dataToBeSelect.TicketStatus,
  //       // Organization:
  //       //   dataToBeSelect.Organization === null
  //       //     ? []
  //       //     : dataToBeSelect.Organization,
  //       // System: dataToBeSelect.System === null ? [] : dataToBeSelect.System,
  //       Category:
  //         dataToBeSelect.Category === null ? [] : dataToBeSelect.Category,
  //       Priority:
  //         dataToBeSelect.Priority === null ? [] : dataToBeSelect.Priority,
  //     });
  //   }
  // }, [dataToBeSelect]);

  //#region Button onCLick / Create Response Message
 
  // const createResponseMessage1 = () => {
  //   // if (editData.ACKNOWLEDGED_NAME && editData.originalAgent  !== originalAgent) {
  //   if (editData.ACKNOWLEDGED_NAME?.trim() && editData.ACKNOWLEDGED_NAME.trim() !== originalAgent?.trim()) {
  //     return `Agent changed from [ ${originalAgent} ] to [ ${editData.ACKNOWLEDGED_NAME} ].`;
  //   }
  //   return null;
  // };
  const createResponseMessage1 = () => {
    if (editData.ACKNOWLEDGED_NAME?.trim()) {
      if (!originalAgent?.trim()) {
        // Case where originalAgent is null or empty
        return `New Agent [ ${editData.ACKNOWLEDGED_NAME} ] is assigned / added.`;
      } else if (editData.ACKNOWLEDGED_NAME.trim() !== originalAgentName.trim()) {
        // Case where originalAgent is not null and the agent has changed
        return `Agent changed from [ ${originalAgentName} ] to [ ${editData.ACKNOWLEDGED_NAME} ].`;
      }
    }
    // No message if conditions are not met
    return null;
  };

  const createResponseMessage2 = () => {
    const currentOwner = editData.CREATE_NAME || "No Owner";
    if (currentOwner  !== originalOwner) {
      return `Ticket owner changed from [ ${originalOwner} ] to [ ${editData.CREATE_NAME} ].`;
    }
    return null;
  };

    const createResponseMessage3 = () => {
    if (editData.ORG_NAME?.trim()) {
      if (!originalCompany?.trim()) {
        // Case where originalCompany is null or empty
        return `New Company [ ${editData.ORG_NAME} ] is assigned / added.`;
      } else if (editData.ORG_NAME.trim() !== originalCompany.trim()) {
        // Case where originalCompany is not null and the company has changed
        return `Company changed from [ ${originalCompany} ] to [ ${editData.ORG_NAME} ].`;
      }
    }
    // No message if conditions are not met
    return null;
  };

  const createResponseMessage4 = () => {
    if (editData.SYSTEM_MST_NAME?.trim()) {
      if (!originalSystem?.trim()) {
        // Case where originalSystem is null or empty
        return `New System [ ${editData.SYSTEM_MST_NAME} ] is assigned / added.`;
      } else if (editData.SYSTEM_MST_NAME.trim() !== originalSystem.trim()) {
        // Case where originalSystem is not null and the system has changed
        return `System changed from [ ${originalSystem} ] to [ ${editData.SYSTEM_MST_NAME} ].`;
      }
    }
    // No message if conditions are not met
    return null;
  };

  // const createResponseMessage1 = () => {
  //   if (editData.ACKNOWLEDGED_NAME !== originalAgent) {
  //     return `🕵️ **AGENT CHANGE**: The agent has been updated from [ ${originalAgent} ] to [ ${editData.ACKNOWLEDGED_NAME} ].`;
  //     // return (
  //     //   <>
  //     //       🕵️ <strong>Agent Change</strong>: The agent has been updated from <strong>{originalAgent}</strong> to <strong>{editData.ACKNOWLEDGED_NAME}</strong>.
  //     //   </>
  //     // );
      
  //   }
  //   return null;
  // };

  // const createResponseMessage2 = () => {
  //   if (editData.CREATE_NAME !== originalOwner) {
  //     return `👤 **OWNER CHANGE**: The ticket owner has been updated from [ ${originalOwner} ] to [ ${editData.CREATE_NAME} ].`;
  //     // return (
  //     //   <>
  //     //       👤 <strong>Owner Change</strong>: The ticket owner has been updated from <strong>{originalOwner}</strong> to <strong>{editData.CREATE_NAME}</strong>.
  //     //   </>
  //     // );
      
  //   }
  //   return null;
  // };

  const updateBtnOnClick = () => {
    if (Object.values(inputError).filter((v) => v !== "").length === 0) {
      const responseMessage1 = createResponseMessage1();
      const responseMessage2 = createResponseMessage2();
      const responseMessage3 = createResponseMessage3();
      const responseMessage4 = createResponseMessage4();
      //console.log("Company Change:", createResponseMessage3());
      //console.log("System Change:", createResponseMessage4());

  
      const combinedMessages = [];
  
        if (responseMessage1) {
            combinedMessages.push(responseMessage1); 
        }

        if (responseMessage2) {
            combinedMessages.push(responseMessage2); 
        }

        if (responseMessage3) {
            combinedMessages.push(responseMessage3); 
        }

        if (responseMessage4) {
            combinedMessages.push(responseMessage4); 
        }

      // Combine messages into a single string with newlines
      const generatedResponseDetails = combinedMessages.length > 0
      ? combinedMessages.join('\n') // Join with newline
      : editData.RESPONSE_DETAILS || ''; // Fallback to existing response details
  
      // Pass the generated response details directly into SaveEditTicket
      SaveEditTicket({ 
        ...editData, 
        RESPONSE_DETAILS: generatedResponseDetails.trim()
      });
    }
  };

  function SaveEditTicket(_data) {
    let functionName = "";
    try {
      functionName = SaveEditTicket.name;

      onLoadingHandler(true, "Editing ticket, please wait...");

      // const data = {
      //   TICKET_MST_ID: _data.TICKET_MST_ID,
      //   TICKET_NUM: _data.TICKET_NUM,
      //   ORG_ID: _data.ORG_ID,
      //   ORG_NAME: _data.ORG_NAME,
      //   SYSTEM_MST_ID: _data.SYSTEM_MST_ID,
      //   SYSTEM_MST_NAME: _data.SYSTEM_MST_NAME,
      //   SUBJECT: _data.SUBJECT,
      //   TICKET_DETAILS: _data.TICKET_DETAILS,
      //   RESPONSE_DETAILS: _data.RESPONSE_DETAILS,
      //   CREATE_BY: _data.CREATE_BY,
      //   CREATE_NAME: _data.CREATE_NAME,
      //   // CREATE_DATETIME: data.CREATE_DATETIME,
      //   // TICKET_STATUS_TYPE_ID: _data.TICKET_STATUS.key,
      //   // TICKET_STATUS_TYPE_NAME: _data.TICKET_STATUS.label,
      //   // TICKET_CATEGORY_ID: _data.CATEGORY.key,
      //   // TICKET_PRIORITY_TYPE_ID: _data.PRIORITY.key,
      //   // ACKNOWLEDGED_BY: _data.ACKNOWLEDGED_BY,
      //   // ACKNOWLEDGED_NAME: _data.ACKNOWLEDGED_NAME,
      //   // ACKNOWLEDGED_DATETIME:
      //   //   _data.ACKNOWLEDGED_DATETIME === "0001-01-01T00:00:00"
      //   //     ? null
      //   //     : _data.ACKNOWLEDGED_DATETIME,
      //   // TARGET_MANDAYS: _data.TARGET_MANDAYS,
      //   // TOTAL_COMPLETE_TIME: _data.TOTAL_COMPLETE_TIME,
      //   ATTACHMENT_ID: _data.ATTACHMENT_ID,
      //   INTERNAL_NOTE: _data.INTERNAL_NOTE,
      //   UPDATE_ID: userId,
      //   UPDATE_DATETIME: _data.UPDATE_DATETIME,
      // };

      const data = {
        TICKET_MST_ID: _data.TICKET_MST_ID,
        TICKET_NUM: _data.TICKET_NUM,
        ORG_ID: _data.ORG_ID,
        ORG_NAME: _data.ORG_NAME,
        SYSTEM_MST_ID: _data.SYSTEM_MST_ID,
        SYSTEM_MST_NAME: _data.SYSTEM_MST_NAME,
        SUBJECT: _data.SUBJECT,
        TICKET_DETAILS: _data.TICKET_DETAILS,
        RESPONSE_DETAILS: _data.RESPONSE_DETAILS,
        CREATE_BY: _data.CREATE_BY,
        CREATE_NAME: _data.CREATE_NAME,
        ATTACHMENT_ID: _data.ATTACHMENT_ID,
        INTERNAL_NOTE: _data.INTERNAL_NOTE,
        UPDATE_ID: userId,
        UPDATE_DATETIME: _data.UPDATE_DATETIME,
      };

      // Only include ack fields if the current user is allowed to modify the agent (internal)
      if (modifyAuthority && modifyAuthority.MODIFY_AGENT === "Y") {
        data.ACKNOWLEDGED_BY = _data.ACKNOWLEDGED_BY;
        data.ACKNOWLEDGED_NAME = _data.ACKNOWLEDGED_NAME;
        data.ACKNOWLEDGED_DATETIME = 
            _data.ACKNOWLEDGED_DATETIME === "0001-01-01T00:00:00" ? null : _data.ACKNOWLEDGED_DATETIME;
      }

      http
        .put("api/ticket/UpdateTicket", data, { timeout: 10000 })
        .then((response) => {
          if (response.data.CLOSE_STATUS === true || response.data.CANCEL_STATUS === true) {
            if (response.data.TICKET_STATUS_TYPE_NAME === "CLOSED") {
              toast.error("Ticket " + response.data.TICKET_NUM + " has been " + response.data.TICKET_STATUS_TYPE_NAME.toLowerCase() + '.');   
            } else if (response.data.TICKET_STATUS_TYPE_NAME === "CANCEL") {
              toast.error("Ticket " + response.data.TICKET_NUM + " has been " + response.data.TICKET_STATUS_TYPE_NAME.toLowerCase() + 'led.');   
            } 
            onReloadHandler();
          } else {
            if (_data.RESPONSE_DETAILS?.trim()) {
                  toast.success("Ticket is successfully updated.\n\n" + _data.RESPONSE_DETAILS);
                } else {
                  toast.success("Ticket is successfully updated.");
                }
            //toast.success("Ticket is successfully updated.");
            try {
              onLoadingHandler(true, "Sending email, please wait...");
              const data = {
                  TICKET_MST_ID: _data.TICKET_MST_ID,
                  TICKET_NUM: _data.TICKET_NUM, 
                  SUBJECT: _data.SUBJECT,
                  TICKET_DETAILS: _data.TICKET_DETAILS,
                  RESPONSE_DETAILS: _data.RESPONSE_DETAILS,
                  CREATE_BY: _data.CREATE_BY,
                  CREATE_NAME: _data.CREATE_NAME,
                  // ACKNOWLEDGED_BY: _data.ACKNOWLEDGED_BY,
                  // ACKNOWLEDGED_NAME: _data.ACKNOWLEDGED_NAME,
                  // ACKNOWLEDGED_DATETIME:
                  //   _data.ACKNOWLEDGED_DATETIME === "0001-01-01T00:00:00"
                  //     ? null
                  //     : _data.ACKNOWLEDGED_DATETIME,
                  ATTACHMENT_ID: _data.ATTACHMENT_ID,
                  INTERNAL_NOTE: _data.INTERNAL_NOTE,
                  UPDATE_ID: userId,
                  UPDATE_DATETIME: _data.UPDATE_DATETIME,
              };

              if (modifyAuthority && modifyAuthority.MODIFY_AGENT === "Y") {
                data.ACKNOWLEDGED_BY = _data.ACKNOWLEDGED_BY;
                data.ACKNOWLEDGED_NAME = _data.ACKNOWLEDGED_NAME;
                data.ACKNOWLEDGED_DATETIME =
                  _data.ACKNOWLEDGED_DATETIME === "0001-01-01T00:00:00"
                    ? null
                    : _data.ACKNOWLEDGED_DATETIME;
              }
              // http
              //     .post("api/Ticket/SendUpdateEmail", data, { timeout: 10000 })
              //     .then((response) => {
              //       onLoadingHandler(true, "Sending email...");
              //     })
              //     .catch((err) => {    
              //         common.c_LogWebError(props.page, functionName, err);
              //     })
              //     .finally(() => {
              //         onLoadingHandler(false, "Loading...");
              //     })

              //console.log (data.ACKNOWLEDGED_BY, data.OLD_ACKNOWLEDGED_BY)

              // Check agent change
              if (originalAgent !== undefined && (originalAgent !== _data.ACKNOWLEDGED_BY)) {
                // New agent assigned
                http.post("api/Ticket/SendNewAgentAssignedEmail", {
                  ...data,
                  OLD_ACKNOWLEDGED_BY: _data.OLD_ACKNOWLEDGED_BY || originalAgent,    // old agent id
                  OLD_ACKNOWLEDGED_NAME: _data.OLD_ACKNOWLEDGED_NAME || originalAgentName, // old agent name
                }, { timeout: 10000 })
                .then(() => console.log("New agent email sent."))
                .catch(err => common.c_LogWebError(props.page, "SendNewAgentAssignedEmail", err));
              } else {
                // normal update
                http.post("api/Ticket/SendUpdateEmail", data, { timeout: 10000 })
                .catch(err => common.c_LogWebError(props.page, "SendUpdateEmail", err));
              }

            } catch (err) {
                onLoadingHandler(false, "Loading...");
                toast.error("Failed to send");
                common.c_LogWebError(props.page, functionName, err);
            }
            onReloadHandler();
          }         
        })
        .catch((err) => {
          toast.error("Failed to update ticket. Please try again.");
          common.c_LogWebError(props.page, functionName, err);
        })
        .finally(() => {
          onLoadingHandler(false, "Loading...");
        });
    } catch (err) {
      onLoadingHandler(false, "Loading...");
      toast.error("Failed to update ticket. Please try again.");
      common.c_LogWebError(props.page, functionName, err);
    }
  }

  //#region Handle
  const selectionHandler = (val, field) => {
    let functionName = "";

    try {
      functionName = selectionHandler.name;
      setInputError((prevState) => ({
        ...prevState,
        [field]: "",
      }));
      setEditData((prevState) => ({
        ...prevState,
        [field]: val,
        
      }));
    } catch (err) {
      common.c_LogWebError(props.page, functionName, err);
    }
  };

  const selectAgentDetailHandler = (val) => {
    let functionName = "";
    
    try {
      functionName = selectAgentDetailHandler.name;

      if (val && val.label) { 
        setInputError((prevState) => ({
          ...prevState,
          AGENT: "",
        }));
        setEditData((prevState) => ({
          ...prevState,
          ACKNOWLEDGED_NAME: val.label,
          ACKNOWLEDGED_BY: val.value,
        }));
        
        setSelectedAgentDetail(val);
      } else {

        setInputError((prevState) => ({
          ...prevState,
          AGENT: "Agent could not be empty.",
        }));
      }
    } catch (err) {
      common.c_LogWebError(PAGE_NAME, functionName, err);
    }
  };

  const selectCompanyDetailHandler = (val) => {
    let functionName = "";
    
    try {
      functionName = selectCompanyDetailHandler.name;

      if (val && val.label) { 
        setInputError((prevState) => ({
          ...prevState,
          COMPANY: "",
        }));
        setEditData((prevState) => ({
          ...prevState,
          ORG_NAME: val.label,
          ORG_ID: val.value,
          //ACKNOWLEDGED_BY: val.value,
        }));
        
        setSelectedCompanyDetail(val);

       http
        .get(`api/ticket/GetSystemList?_user=${userId}&_org=${val.value}`)
        .then((response) => {
          const systemList = response.data.map((system) => ({
            label: system.SYSTEM_MST_NAME,
            value: system.SYSTEM_MST_ID,
          }));
          setSystemDetailList(systemList);
          setSelectedSystemDetail(null); // Clear previously selected system
        }); 

      } else {

        setInputError((prevState) => ({
          ...prevState,
          COMPANY: "Company could not be empty.",
        }));
      }
    } catch (err) {
      common.c_LogWebError(PAGE_NAME, functionName, err);
    }
  };

  const selectSystemDetailHandler = (val) => {
    let functionName = "";
    
    try {
      functionName = selectSystemDetailHandler.name;

      if (val && val.label) { 
        setInputError((prevState) => ({
          ...prevState,
          SYSTEM: "",
        }));
        setEditData((prevState) => ({
          ...prevState,
          SYSTEM_MST_NAME: val.label,
          SYSTEM_MST_ID: val.value,
          //ACKNOWLEDGED_BY: val.value,
        }));
        
        setSelectedSystemDetail(val);
      } else {

        setInputError((prevState) => ({
          ...prevState,
          SYSTEM: "System could not be empty.",
        }));
      }
    } catch (err) {
      common.c_LogWebError(PAGE_NAME, functionName, err);
    }
  };
  
  const selectTicketOwnerDetailHandler = (val) => {
    let functionName = "";

    try {
      functionName = selectTicketOwnerDetailHandler.name;

      if (val && val.label) { 
        setInputError((prevState) => ({
          ...prevState,
          TICKET_OWNER: "",
        }));
        setEditData((prevState) => ({
          ...prevState,
          CREATE_NAME: val.label,
          CREATE_BY: val.value,
        }));
        
        setSelectedTicketOwnerDetail(val);
      } else {
        setInputError((prevState) => ({
          ...prevState,
          TICKET_OWNER: "Ticket Owner could not be empty.",
        }));
      }
    } catch (err) {
      common.c_LogWebError(PAGE_NAME, functionName, err);
    }
  };


  const inputUnrequiredHandler = (event) => {
    let functionName = "";

    try {
      functionName = inputUnrequiredHandler.name;
      const id = event.target.id;
      const val = event.target.value;

      setEditData((prevState) => ({
        ...prevState,
        [id]: val,
      }));
    } catch (err) {
      common.c_LogWebError(props.page, functionName, err);
    }
  };

  const inputRequiredHandler = (event) => {
    let functionName = "";

    try {
      functionName = inputRequiredHandler.name;
      const name = event.target.name;
      functionName = inputRequiredHandler.name + "_" + name;
      const id = event.target.id;
      const val = event.target.value;
      if (val.length === 0 || val.trim().length === 0) {
        setInputError((prevState) => ({
          ...prevState,
          [id]: name + " could not be empty.",
        }));
      } else {
        setInputError((prevState) => ({
          ...prevState,
          [id]: "",
        }));
      }
      setEditData((prevState) => ({
        ...prevState,
        [id]: val,
      }));
    } catch (err) {
      common.c_LogWebError(props.page, functionName, err);
    }
  };

  const onLoadingHandler = (load, text) => {
    setLoading(load);
    setLoadingText(text);
  };

  const onReloadHandler = () => {
    setReload(!reload);
  };

  return (
    <>
      <div
        className={CssClass.subtitleBg}
        style={{ backgroundColor: "lightblue" }}
      >
        <h3 className={CssClass.subtitle}>Ticket Information</h3>
      </div>

      <Comp.SearchPanel>
        <tr>
          <td style={{ verticalAlign: "middle", width: "10%" }}>
            Created Date
          </td>
          <td style={{ verticalAlign: "middle", width: "1%" }}>:</td>
          <td style={{ verticalAlign: "middle", width: "15%" }}>
            <label style={{ fontWeight: "normal" }}>
              {/* {editData.CREATE_DATETIME} */}
              {moment(editData.CREATE_DATETIME).format("DD/MM/YYYY hh:mm:ss A")}
            </label>
            {/* <Comp.Input
              id="CREATED_DATETIME"
              type="text"
              className="form-control"
              value={editData.CREATE_DATETIME}
              readOnly={true}
            /> */}
          </td>
          <td style={{ verticalAlign: "middle", width: "10%" }}>Ticket #</td>
          <td style={{ verticalAlign: "middle", width: "1%" }}>:</td>
          <td style={{ verticalAlign: "middle", width: "15%" }}>
            <label style={{ fontWeight: "normal" }}>
              {editData.TICKET_NUM}
            </label>
            {/* <Comp.Input
              ref={ticketNoInputRef}
              id="TICKET_NO"
              type="text"
              className="form-control"
              value={editData.TICKET_NUM}
              readOnly={true}
            /> */}
          </td>
          <td style={{ verticalAlign: "middle", width: "10%" }}>
            Ticket Status
          </td>
          <td style={{ verticalAlign: "middle", width: "1%" }}>:</td>
          <td style={{ verticalAlign: "middle", width: "15%" }}>
            <label style={{ fontWeight: "normal" }}>
              {editData.TICKET_STATUS_TYPE_NAME}
            </label>
            {/* <Comp.Select
              id="TICKET_STATUS"
              options={dataToBeSelect.TicketStatus}
              closeMenuOnSelect={true}
              isClearable={true}
              hideSelectedOptions={false}
              value={editData.TICKET_STATUS}
              onChange={(val) => selectionHandler(val, "TICKET_STATUS")}
              //   onChange={setSelectedTicketStatus}
            /> */}
          </td>
        </tr>

        <tr>
          <td style={{ verticalAlign: "middle", width: "10%" }}>Assigned To</td>
          <td style={{ verticalAlign: "middle", width: "1%" }}>:</td>
          <td style={{ verticalAlign: "middle", width: "15%" }}>
          {modifyAuthority.MODIFY_AGENT === "Y" ? (
            <Comp.Select
            id="AGENT"
            type="text"
            // isDisabled={agentFieldDisabled}
            errorMessage={inputError.AGENT}
            options={agentDetailList.map(agent => ({
              ...agent,
              label: agent.isActive ? agent.label : `${agent.label}  (INACTIVE)`
            }))}
            closeMenuOnSelect
            hideSelectedOptions={false}
            // value={agentDetailList.find(agent => agent.label === editData.ACKNOWLEDGED_NAME) || ""}
            value={agentDetailList.find(agent => agent.label === editData.ACKNOWLEDGED_NAME && selectedAgentDetail || "")}
            onChange={(val) => selectAgentDetailHandler(val)}
          />
          ) : (
            <label style={{ fontWeight: "normal" }}>
              {/* {editData.ACKNOWLEDGED_BY} */}
              {editData.ACKNOWLEDGED_NAME}
            </label>
          )}
          </td>

          <td style={{ verticalAlign: "middle", width: "10%" }}>
            Acknowledged On
          </td>
          <td style={{ verticalAlign: "middle", width: "1%" }}>:</td>
          <td style={{ verticalAlign: "middle", width: "15%" }}>
            <label style={{ fontWeight: "normal" }}>
              {/* {editData.ACKNOWLEDGED_DATETIME} */}
              {moment(editData.ACKNOWLEDGED_DATETIME).format(
                "YYYY-MM-DD HH:mm:ss"
              ) === "0001-01-01 00:00:00"
                ? "-"
                : moment(editData.ACKNOWLEDGED_DATETIME).format(
                    "DD/MM/YYYY hh:mm:ss A"
                  )}
            </label>
          
            
          </td>
          <td style={{ verticalAlign: "middle", width: "10%" }}>
            Target Mandays
          </td>
          <td style={{ verticalAlign: "middle", width: "1%" }}>:</td>
          <td style={{ verticalAlign: "middle", width: "15%" }}>
            {editData.TICKET_STATUS_TYPE_NAME === "CLOSED" || buttonAuthority.UPDATE !== "Y" 
              ? (
                <label style={{ fontWeight: "normal" }}>
                {editData.TARGET_MANDAYS}
              </label>
              ) : (
                <Comp.Input
                  ref={serviceTimeInputRef}
                  id="TARGET_MANDAYS"
                  type="text"
                  className="form-control"
                  value={editData.TARGET_MANDAYS}
                  onChange={inputUnrequiredHandler}
                />
              )
            }       
          </td>
        </tr>
        <tr>
          {/* <td style={{ verticalAlign: "middle", width: "10%" }}>Company</td>
          <td style={{ verticalAlign: "middle", width: "1%" }}>:</td>
          <td style={{ verticalAlign: "middle", width: "15%" }}>
            <label style={{ fontWeight: "normal" }}>{editData.ORG_NAME}</label>
        
          </td> */}
          <td style={{ verticalAlign: "middle", width: "10%" }}>Company</td>
          <td style={{ verticalAlign: "middle", width: "1%" }}>:</td>
          <td style={{ verticalAlign: "middle", width: "15%" }}>
          {modifyAuthority.MODIFY_COMPANY === "Y" ? (
            <Comp.Select
            id="COMPANY"
            type="text"
            // isDisabled={companyFieldDisabled}
            errorMessage={inputError.COMPANY}
            options={companyDetailList.map(company => ({
              ...company,
              //label: company.isActive ? company.label : `${company.label}  (INACTIVE)`
            }))}
            closeMenuOnSelect
            hideSelectedOptions={false}
            value={
              selectedCompanyDetail?.value
                ? selectedCompanyDetail
                : companyDetailList.find(company => company.value === editData.ORG_ID) || null
            }
            onChange={(val) => selectCompanyDetailHandler(val)}
          />
          ) : (
            <label style={{ fontWeight: "normal" }}>
              {/* {editData.ACKNOWLEDGED_BY} */}
              {editData.ORG_NAME}
            </label>
          )}
          </td>

          {/* <td style={{ verticalAlign: "middle", width: "10%" }}>System</td>
          <td style={{ verticalAlign: "middle", width: "1%" }}>:</td>
          <td style={{ verticalAlign: "middle", width: "15%" }}>
            <label style={{ fontWeight: "normal" }}>
              {editData.SYSTEM_MST_NAME}
            </label>
          
          </td> */}
          <td style={{ verticalAlign: "middle", width: "10%" }}>System</td>
          <td style={{ verticalAlign: "middle", width: "1%" }}>:</td>
          <td style={{ verticalAlign: "middle", width: "15%" }}>
          {modifyAuthority.MODIFY_SYSTEM === "Y" ? (
            <Comp.Select
            id="SYSTEM"
            type="text"
            // isDisabled={systemFieldDisabled}
            errorMessage={inputError.SYSTEM}
            options={systemDetailList.map(system => ({
              ...system,
              //label: system.isActive ? system.label : `${system.label}  (INACTIVE)`
            }))}
            closeMenuOnSelect
            hideSelectedOptions={false}
            value={
              selectedSystemDetail?.value
                ? selectedSystemDetail
                : systemDetailList.find(system => system.value === editData.SYSTEM_MST_ID) || null
            }
            onChange={(val) => selectSystemDetailHandler(val)}
          />
          ) : (
            <label style={{ fontWeight: "normal" }}>
              {/* {editData.ACKNOWLEDGED_BY} */}
              {editData.SYSTEM_MST_NAME}
            </label>
          )}
          </td>
        
        </tr>
       
        {viewData.STANDBY_FLAG === "Y" && 
          <tr>
            <td>Standby Start</td>
            <td>:</td>
            <td><label style={{ fontWeight: "normal" }}>{moment(editData.FROM_DATETIME).format("DD/MM/YYYY hh:mm:ss A")}</label></td>
            <td>Standby End</td>
            <td>:</td>
            <td><label style={{ fontWeight: "normal" }}>{moment(editData.TO_DATETIME).format("DD/MM/YYYY hh:mm:ss A")}</label></td>
            <td style={{ verticalAlign: "middle", width: "10%" }}>
                  Standby Mandays 
            </td>
            <td style={{ verticalAlign: "middle", width: "1%" }}>:</td>
            <td>
              {editData.TICKET_STATUS_TYPE_NAME === "CLOSED" || buttonAuthority.UPDATE !== "Y" 
                ? (
                  <label style={{ fontWeight: "normal" }}>
                  {editData.STANDBY_TARGET_MANDAYS}
                </label>
                ) : (
                  <Comp.Input
                    ref={standbyTargetMandaysRef}
                    id="STANDBY_TARGET_MANDAYS"
                    type="text"
                    className="form-control"
                    value={editData.STANDBY_TARGET_MANDAYS}
                    onChange={inputUnrequiredHandler}
                  />
                )
              }
            </td>
          </tr> 
        }
        {editData.TICKET_STATUS_TYPE_NAME === "CANCEL" && (
        <tr>
          <td>Cancelled By</td>
          <td>:</td>
          <td>
            <label style={{ fontWeight: "normal" }}>
              {editData.CANCELLED_NAME}
            </label>
          </td>
          <td>Cancelled On</td>
          <td>:</td>
          <td>
            <label style={{ fontWeight: "normal" }}>
              {moment(editData.CANCELLED_DATETIME).format("DD/MM/YYYY hh:mm:ss A")}
            </label>
          </td>
          <td>Cancelled Reason</td>
          <td>:</td>
          <td>
            <label style={{ fontWeight: "normal" }}>
                  {editData.RESPONSE_DETAILS}
            </label>
          </td>
        </tr>
        )}
        
        <tr>
          <td>Ticket Owner</td>
          <td> :</td>
          <td colSpan={7}>
          
            {modifyAuthority.MODIFY_TICKET_OWNER === "Y" ? (
                <Comp.Select
                  id="TICKET_OWNER"
                  type="text"
                  // isDisabled={ticketOwnerFieldDisabled}
                  errorMessage={inputError.TICKET_OWNER}
                  // options={ticketOwnerDetailList}
                  options={ticketOwnerDetailList.map(ticketOwner => ({
                    ...ticketOwner,
                    label: ticketOwner.isActive ? ticketOwner.label : `${ticketOwner.label}  (INACTIVE)`
                  }))}
                  closeMenuOnSelect
                  hideSelectedOptions={false}
                  // value={ticketOwnerDetailList.find(ticketOwner => ticketOwner.label === editData.CREATE_NAME) || ""}
                  value={ticketOwnerDetailList.find(ticketOwner => ticketOwner.label === editData.CREATE_NAME && selectedTicketOwnerDetail || "")}
                  onChange={(val) => selectTicketOwnerDetailHandler(val)}
                />
            ) : (
              <label style={{ fontWeight: "normal" }}>{editData.CREATE_NAME}</label>
            )}
          </td>
        </tr>
        <tr>
          <td>Title</td>
          <td> :</td>
          <td colSpan={7}>
            {editData.TICKET_STATUS_TYPE_NAME === "CLOSED" || buttonAuthority.UPDATE !== "Y" ? (
              <label style={{ fontWeight: "normal" }}>{editData.SUBJECT}</label>
            ) : (
              <Comp.Input
                ref={subjectInputRef}
                id="SUBJECT"
                type="text"
                className="form-control"
                value={editData.SUBJECT}
                errorMessage={inputError.SUBJECT}
                onChange={inputRequiredHandler}
              />
            )}
          </td>
        </tr>
        <tr>
          <td>Details</td>
          <td> :</td>
          <td colSpan={7}>
            {editData.TICKET_STATUS_TYPE_NAME === "CLOSED" || buttonAuthority.UPDATE !== "Y" ? (
              <Comp.TextArea
                ref={detailsInputRef}
                id="TICKET_DETAILS"
                type="text"
                rows="5"
                className="form-control"
                value={editData.TICKET_DETAILS}
                readOnly={true}
              />
            ) : (
              <Comp.TextArea
                ref={detailsInputRef}
                id="TICKET_DETAILS"
                type="text"
                rows="5"
                className="form-control"
                value={editData.TICKET_DETAILS}
                errorMessage={inputError.TICKET_DETAILS}
                onChange={inputRequiredHandler}
              />
            )}
          </td>
        </tr>
        {buttonAuthority.ACKNOWLEDGE === "Y" && (
          <tr>
            <td>Internal Remark</td>
            <td> :</td>
            <td colSpan={7}>
              {editData.TICKET_STATUS_TYPE_NAME === "CLOSED" 
              ? (
                <Comp.TextArea
                  ref={remarkInputRef}
                  id="INTERNAL_NOTE"
                  type="text"
                  rows="5"
                  className="form-control"
                  value={editData.INTERNAL_NOTE}
                  readOnly={true}
                />
              ) : (
                <Comp.TextArea
                  ref={remarkInputRef}
                  id="INTERNAL_NOTE"
                  type="text"
                  rows="5"
                  className="form-control"
                  value={editData.INTERNAL_NOTE}
                  onChange={inputUnrequiredHandler}
                />
              )}          
            </td>
          </tr>
        )}     
        <tr>
          <td>Uploaded File</td>
          <td> :</td>
          <td colSpan={7}>
            {ticketAttachment.length > 0 
              ? <Comp.Button onClick={showAttachmentModal}>VIEW</Comp.Button>
              : '-'
            }
            
          </td>
        </tr>
      </Comp.SearchPanel> 

      <div className={CssClass.btnWrapper}>
      {actionAuthority.WRITE === 'Y' && (
        <>
          {buttonAuthority.UPDATE === "Y" && editData.TICKET_STATUS_TYPE_NAME !== "CLOSED" && editData.TICKET_STATUS_TYPE_NAME !== "CANCEL" && (
            <Comp.Button style={{width: "110px"}} id="btnSave" type="general" onClick={updateBtnOnClick}>
              UPDATE
            </Comp.Button>
          )}

          {buttonAuthority.ACKNOWLEDGE === "Y" && editData.TICKET_STATUS_TYPE_NAME === "OPEN" && (
            <Comp.Button style={{width: "110px"}} id="btnSave" type="general" onClick={showAckModal}>
              ACKNOWLEDGE
            </Comp.Button>
          )}

          {buttonAuthority.CLOSE === "Y" && editData.TICKET_STATUS_TYPE_NAME === "VERIFIED" && (
            <Comp.Button style={{width: "110px"}} id="btnSave" type="general" onClick={showCloseModal}>
              CLOSE
            </Comp.Button>

          )} 
          {buttonAuthority.CANCEL === "Y" && editData.TICKET_STATUS_TYPE_NAME !== "CLOSED" && editData.TICKET_STATUS_TYPE_NAME !== "CANCEL" &&
            <Comp.Button style={{width: "110px"}} id="btnCancel" type="delete" onClick={showCancelModal}>
              CANCEL
            </Comp.Button>
          } 
          {buttonAuthority.REVERSE_STATUS === "Y" && editData.TICKET_STATUS_TYPE_NAME === "ACKNOWLEDGE" && (
            <Comp.Button style={{width: "110px"}} id="btnReverse" type="delete" onClick={showReverseModal}>
              REV. STATUS
            </Comp.Button>           
            )}
            {editData.VERIFY_DETAIL != null && editData.VERIFY_DETAIL.length > 0 &&(
              <Comp.Button style={{width: "110px"}} id="btnVerify" type="resolve" onClick={showVerifyModal}>
                VERIFY
              </Comp.Button>           
            )}   
            {buttonAuthority.RESOLVE === "Y" && editData.TICKET_STATUS_TYPE_NAME === "ACKNOWLEDGE" && (
            <Comp.Button style={{width: "110px"}} id="btnResolve" type="resolve" onClick={showResolveModal}>
              RESOLVE
            </Comp.Button>           
          )}    
        </>   
      )}
      {/* SystemAttachment */}
      {buttonAuthority.ACKNOWLEDGE === "Y" && systemAttachment.length > 0 && (
          <Comp.Button
            size= "xxl"
            type= "purple"
            onClick={() => {
              const attachmentId = systemAttachment[0].ATTACHMENT_ID;

              const url = `${common.c_getApiUrl()}api/SystemSetup/DownloadSystemAttachment?_attachmentId=${attachmentId}`;

              window.open(url, "_blank");
            }}
          >
            DEPLOY FORM TEMPLATE 
          </Comp.Button>
        )}
      </div>

     <div
        className={CssClass.subtitleBg}
        style={{ backgroundColor: "lightblue" }}
      >
        <h3 className={CssClass.subtitle}>Response</h3>
      </div>
      {buttonAuthority.POST_REPLY === "Y" && actionAuthority.WRITE === 'Y' && (
        editData.TICKET_STATUS_TYPE_NAME !== "CLOSED" && editData.TICKET_STATUS_TYPE_NAME !== "CANCEL" && (
          <div className={CssClass.btnWrapper}>
          <Comp.Button id="btnRegister" type="general" onClick={showReplyModal}>
            POST REPLY
          </Comp.Button>
        </div>
        )
      )}

      <div className={`${CssClass.card} ${CssClass.tableCard}`}>
        {/* <h3 className={CssClass.tableTitle}>List of Ticket</h3> */}
        <div style={{ width: "100%" }}>

          <NewResponseChat
            page={PAGE_NAME}
            module={MODULE_ID}
            data={[...(verifiedData || []), ...(resolvedData || []), ...(closedData || []), ...(responseData || [])].sort(
              (a, b) => new Date(b.UPDATE_DATETIME) - new Date(a.UPDATE_DATETIME)
            )}
            onReload={onReloadHandler}
            onLoading={onLoadingHandler}
            authority={buttonAuthority}
            reloadData={() => setReload(!reload)}
          />
        </div>
      </div>
      <TicketAttachmentModal
        showHide={showAttachment}
        onHide={hideAttachmentModal}
        ticketAttachment={ticketAttachment}
        onReload={onReloadHandler}
        onLoading={onLoadingHandler}
      />

      <PostReply
        page={PAGE_NAME}
        module={MODULE_ID}
        showHide={showReply}
        onHide={hideReplyModal}
        onReload={onReloadHandler}
        onLoading={onLoadingHandler}
        viewData={editData}
        dataToBeSelect={dataToBeSelect.EMAIL_TO}
        systemAttachment={systemAttachment}
      />
      <AckTicket
        page={PAGE_NAME}
        showHide={showAck}
        viewData={editData}
        onHide={hideAckModal}
        onReload={onReloadHandler}
        onLoading={onLoadingHandler}
      />
      <CloseTicket
        page={PAGE_NAME}
        showHide={showClose}
        viewData={editData}
        onHide={hideCloseModal}
        onReload={onReloadHandler}
        onLoading={onLoadingHandler}
      />
      <CancelTicket
        page={PAGE_NAME}
        showHide={showCancel}
        viewData={editData}
        onHide={hideCancelModal}
        onReload={onReloadHandler}
        onLoading={onLoadingHandler}
      />
      <ReverseTicketStatus
        page={PAGE_NAME}
        showHide={showReverse}
        viewData={editData}
        onHide={hideReverseModal}
        onReload={onReloadHandler}
        onLoading={onLoadingHandler}
      />
       <ResolveTicket
        page={PAGE_NAME}
        showHide={showResolve}
        viewData={editData}
        onHide={hideResolveModal}
        onReload={onReloadHandler}
        onLoading={onLoadingHandler}
      />
       <VerifyTicket
        page={PAGE_NAME}
        showHide={showVerify}
        viewData={editData}
        buttonAuthority={buttonAuthority}
        onHide={hideVerifyModal} 
        onShow={showVerifyModal}
        onReload={onReloadHandler}
        onLoading={onLoadingHandler}
      />
      {loading && <Comp.Loading>{loadingText}</Comp.Loading>}
      <Comp.AlertPopup />
    </>
  );
};

export default ViewTicket;
